import { useEffect, useState } from 'react'
import { PeopleService } from '../../../Component/Api/People/peopleService';
import { DataTable } from '../../../Component/Common/Components/DataTable/DataTable';
import { ScorecardLink } from '../../../Component/Model/Dto/PeopleScorecardLink';
import { EntriesPerPage } from '../../../Component/Model/Table/Table';
import { ScorecardLinksTableMapper } from './peopleScorecardLinksColumn';

interface IProps {
    personId: number;
    counter: number;
}

export const PeopleScorecardLinks = (props: IProps) => {

    const [pageNumber, setPageNumber] = useState<number>(1);
    const [searchValue, setSearchValue] = useState<string>("");
    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
    const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [scorecardLinksData, setScorecardLinksData] = useState<ScorecardLink.DtoOut[]>([]);

    const peopleScorecardSearchRequest: ScorecardLink.SearchRequest = {
        pageNumber: pageNumber,
        pageSize: entriesPerPage.defaultValue!,
        searchValue: searchValue,
        personId: props.personId
    }

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }
    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }
    const searchValueChanged = (value: string) => {
        setSearchValue(value);
        setPageNumber(1);
    }

    const fetchUserScorecards = async () => {
        setIsLoading(true);
        try {
            const getScorecardLinks = await PeopleService.GetScorecardLinks(peopleScorecardSearchRequest);
            setScorecardLinksData(getScorecardLinks.data.results);
            setTotalItemsCount(getScorecardLinks.data.totalItemsCount);
            setFilteredItemsCount(getScorecardLinks.data.filteredItemsCount);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchUserScorecards();
    }, [pageNumber, entriesPerPage, searchValue])

    const unlinkScorecard = (scorecardId: string) => {
        
    }

    const scorecardLinksTableData = ScorecardLinksTableMapper(scorecardLinksData, unlinkScorecard);
    return (
        <DataTable
            key={props.counter}
            table={scorecardLinksTableData}
            entriesPerPage={entriesPerPage}
            pageNumber={pageNumber}
            totalItemsCount={totalItemsCount}
            entriesPerPageChanged={entriesPerPageChanged}
            pageNumberChanged={pageNumberChanged}
            isLoading={isLoading}
            canSearch
            searchValueChanged={searchValueChanged}
            filteredItemsCount={filteredItemsCount}

        ></DataTable>
    )
}
